import React from 'react'
import { useBenefits } from '../BenefitsProvider'
import { useTranslation } from '../../../hooks/useTranslation'
import { Button } from '~/components/_atoms/index'
import { CoachHeader, CoachHeaderLight } from '../CoachHeader'

const CoachServicesPage = ({ description, children }) => {
  const { coach } = useBenefits()
  const { t } = useTranslation('benefits_section')
  const { isLiaison } = coach

  return (
    <div className="w-full gap-6 p-4 md:p-9">
      <div className="mb-4">
        <MessageCoachWrapper>
          <CoachHeader>
            <CoachHeaderLight>{t('title_light')} </CoachHeaderLight>
            {isLiaison ? t('title_dark_liaison') : t('title_dark')}
          </CoachHeader>
          <p>
            {description ? (
              <div className="my-4">{description}</div>
            ) : isLiaison ? (
              t('liaison_description')
            ) : (
              t('description')
            )}
          </p>
        </MessageCoachWrapper>
      </div>
      {children}
    </div>
  )
}

export default CoachServicesPage

const MessageCoachWrapper = ({ children }) => {
  const { t } = useTranslation()
  const { serviceRequestList, select } = useBenefits()
  const calendlyEvent =
    serviceRequestList['ServiceRequest::OrientationCall']?.calendly_event

  const introCallScheduled =
    select && calendlyEvent && calendlyEvent['start_time']

  if (introCallScheduled) {
    return (
      <div className="flex justify-between">
        <div>{children}</div>
        <Button
          color="secondary"
          className="open-chat-modal mb-10 self-start"
          data-toggle="modal"
          data-target="#coach_chat_list"
        >
          {t('message_coach')}
        </Button>
      </div>
    )
  }
  return children
}
